module.exports = __webpack_public_path__ + "img/update.3580cf37.svg";